<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">Co-Chain</p>
      <p class="txt">低成本快速搭建自有区块链平台</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/product/part1-bg.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">产品介绍</p>
      <div class="line">
        Co-Chain是基于SDChain开源底层核心平台，扩展出来具有同等功能的全新区块链平台。
        <br>
        Co-Chain 技术所有权属于SDChain Alliance。
      </div>

    </div>

    <!-- <div class="part3">
      <p class="tit">产品架构</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/product/platform/part3.png"
          alt=""
        >
      </div>
    </div> -->

    <div class="part4">
      <p class="tit">产品特性及优势</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/CoChain/part4-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">一键发链</p>
            <p class="text">
              Co-Chain的部署简单方便，可以节省大量的人力和时间成本
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/CoChain/part4-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">一链一生态</p>
            <p class="text">
              独立完整的区块链生态，具备恒为区块链底层核心平台的所有功能
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/CoChain/part4-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">环境共享</p>
            <p class="text">
              Co-Chain之间可以实现互通，交换和共享不同生态产生的数据和价值
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/CoChain/part4-4.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">性能优越</p>
            <p class="text">
              Co-Chain具备与恒为区块链底层核心平台同等性能
            </p>
          </div>
        </div>
      </div>

    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  background: linear-gradient(-30deg, #192F9C, #1185E9);
  position: relative;
  part1();
  padding-top: vw(60);

  .tit {
    margin-bottom: vw(25);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(50);
    text-align: center;

    img {
      width: vw(314);
      height: vw(350);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .line {
    font-size: vw(28);
    color: #666666;
    line-height: vw(48);
    margin-bottom: vw(30);
    padding: 0 vw(30);
  }
}

.part3 {
  part();
  padding: vw(80) 0 vw(100);
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .img {
    text-align: center;

    img {
      width: vw(690);
      height: vw(364);
    }
  }
}

.part4 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(231);
      margin: 0 auto vw(30);
      padding: vw(58) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
        }
      }
    }
  }
}

.part5 {
  part();
  background: #fff;
  padding: vw(80) vw(17) vw(50);

  .tit {
    tit3();
    margin-bottom: vw(50);
  }

  .content {
    display: flex;
    flex-wrap: wrap;

    .card {
      width: vw(170);
      height: vw(170);
      margin: 0 vw(33) vw(30);
      border-radius: vw(10);
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .img {
        text-align: center;
        margin: vw(37) 0 vw(20px);

        img {
          width: vw(50);
          height: vw(50);
        }
      }

      p {
        font-size: vw(24);
        color: #444444;
        text-align: center;
        line-height: vw(24);
      }
    }
  }
}
</style>
